import { apiClient } from "@/lib/api/client";
import { ApiEnvelope } from "@/types/api";
import { AuthUser, LoginPayload, ForgotPasswordInput, ResendOtpInput, ResetPasswordInput, CompleteProfileInput } from "@/types/auth";

export function login(payload: LoginPayload): Promise<ApiEnvelope<AuthUser>> {
  return apiClient.post<AuthUser>("/api_partner/login", payload);
}

export function me(): Promise<ApiEnvelope<AuthUser>> {
  return apiClient.get<AuthUser>("/api_partner/me");
}

export function logout(): Promise<ApiEnvelope<null>> {
  return apiClient.post<null>("/api_partner/logout", {});
}

export function forgotPassword(input: ForgotPasswordInput): Promise<ApiEnvelope<null>> {
  return apiClient.post<null>('/api_partner/forgot_password', input);
}

export function resendOtp(input: ResendOtpInput): Promise<ApiEnvelope<null>> {
  return apiClient.post<null>('/api_partner/resend_otp', input);
}

export function resetPassword(input: ResetPasswordInput): Promise<ApiEnvelope<null>> {
  return apiClient.post<null>('/api_partner/reset_password', input);
}

export function completeProfile(input: CompleteProfileInput): Promise<ApiEnvelope<null>> {
  return apiClient.post<null>('/api_partner/complete_profile', input);
}
